<template>
	<div class="app-container calendar-list-container">
		<basic-container>
			<el-row>
				<el-col :span="6">
					<el-scrollbar style="height: 606px; padding-right: 15px">
						<treeselect
							v-if="initFlag"
							clearable
							:maxHeight="600"
							ref="treeselect"
							:options="treeData"
							:cacheOptions="false"
							@select="chooseTree"
							alwaysOpen
							noChildrenText="没有子节点"
							noOptionsText="暂无数据"
							noResultsText="暂无结果"
							loadingText="加载中"
							@keydown.native="assetTreeKeydownFun"
							searchPromptText="暂无数据,可以输入关键字进行查询"
							:normalizer="normalizer"
							:appendToBody="true"
							@search-change="treeSearchChange"
							:load-options="Isasync ? asyncOptions : loadOptions"
							@open="itemopen"
							:async="Isasync"
							@close="itemClose"
							placeholder="输入关键字进行过滤">
							<template slot="option-label" slot-scope="{node, data}">
								<span style="font-size: 14px; color: #606266">
									<span :style="{color: node.isNew ? '#ff9900' : '#606266'}">{{ node.label }}</span>
								</span>
							</template>

							<!-- <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}444</div> -->
						</treeselect>
					</el-scrollbar>
				</el-col>
				<el-col :span="18">
					<avue-crud
						ref="crud"
						v-model="form"
						:cell-style="cellStyle"
						:data="list"
						:option="option"
						:page.sync="page"
						:table-loading="listLoading"
						style="height: calc(100vh - 180px); overflow: scroll"
						@on-load="getRightList"
						@search-change="searchChange"
						@refresh-change="refreshChange"
						@size-change="sizeChange"
						@row-click="onRowClick"
						@current-change="currentChange"
						@search-reset="searchReset">
						<template slot="userName" slot-scope="scope">
							<span>{{ scope.row.userName }}</span>
						</template>
						<template slot="loginName" slot-scope="scope">
							<span>{{ scope.row.loginName }}</span>
						</template>
						<template slot="mobile" slot-scope="scope">
							<span>{{ scope.row.mobile }}</span>
						</template>
					</avue-crud>
				</el-col>
			</el-row>
		</basic-container>
	</div>
</template>

<script>
import {fetchTree, distChannelByName} from '@/api/team/place'
import {fetchList} from '@/api/team/staff'
import {areaList, dictList} from '@/api/dist/dict'
import {mapGetters} from 'vuex'
import {rule} from '@/util/validateRules'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {Loading} from 'element-ui'
import {LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH} from '@riophae/vue-treeselect'
export default {
	name: 'Dept',
	components: {Treeselect},
	data() {
		return {
			filterText: '',
			initFlag: false,
			total: null,
			loading: null,
			formEdit: true,
			formAdd: true,
			typeOptions: ['0', '1'],
			methodOptions: ['GET', 'POST', 'PUT', 'DELETE'],
			listQuery: {
				name: undefined,
			},
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			rules: {},
			labelPosition: 'right',
			channelAttrList: [],
			channelFromList: [],
			areaList: [],
			currentId: '',

			searchForm: {},
			treeOption: {
				nodeKey: 'id',
				addBtn: false,
				menu: false,
				props: {
					label: 'name',
					value: 'id',
				},
			},
			treeData: [],
			option: {
				card: true,
				border: true,
				index: true,
				indexLabel: '序号',
				stripe: true,
				menu: false,
				menuAlign: 'center',
				searchMenuSpan: 6,
				editBtn: false,
				delBtn: false,
				align: 'center',
				addBtn: false,
				excelBtn: false,
				column: [
					{
						fixed: true,
						label: 'id',
						prop: 'id',
						span: 24,
						hide: true,
						editDisplay: false,
						addDisplay: false,
					},
					{
						fixed: true,
						label: '姓名',
						prop: 'userName',
						slot: true,
						search: true,
						span: 12,
						rules: [
							{
								required: true,
								message: '请输入内勤人员姓名',
							},
							{
								min: 2,
								max: 10,
								message: '长度在 2 到 10 个字符',
								trigger: 'blur',
							},
						],
					},
					{
						label: '手机号',
						prop: 'mobile',
						value: '',
						search: true,
						span: 12,
						rules: [
							{
								min: 11,
								max: 11,
								message: '请输入正确的手机号码',
								trigger: 'blur',
							},
							{
								validator: rule.validatorMobile,
								trigger: 'blur',
							},
						],
					},
					{
						fixed: true,
						label: '登录名',
						prop: 'loginName',
						editDisabled: true,
						slot: true,
						search: true,
						span: 12,
						width: 160,
						rules: [
							{
								required: true,
								message: '请输入登录名',
							},
							{
								min: 8,
								max: 20,
								message: '长度在 8 到 20 个字符',
								trigger: 'blur',
							},
						],
					},
					{
						label: '登录密码',
						prop: 'password',
						type: 'password',
						addDisabled: false,
						editDisabled: false,
						hide: true,
						span: 8,
						rules: [
							{
								required: true,
								validator: rule.validatorPass,
								trigger: 'blur',
							},
						],
					},
					{
						label: '修改密码',
						type: 'switch',
						prop: 'changepassword',
						slot: false,
						border: false,
						hide: true,
						editDisplay: true,
						addDisplay: false,
						span: 4,
						value: 0,
						dicData: [
							{
								label: '否',
								value: 0,
							},
							{
								label: '是',
								value: 1,
							},
						],
					},
					{
						label: '角色',
						prop: 'role',
						value: 6,
						hide: false,
						editDisplay: false,
						addDisplay: false,
						dicData: [
							{
								label: '主渠道管理员',
								value: 4,
							},
							{
								label: '子渠道管理员',
								value: 5,
							},
							{
								label: '内勤',
								value: 6,
							},
							{
								label: '分享录单',
								value: 7,
							},
						],
					},
					{
						label: '状态',
						prop: 'status',
						type: 'switch',
						slot: false,
						border: false,
						search: true,
						span: 12,
						value: 1,
						dicData: [
							{
								label: '停用',
								value: 0,
							},
							{
								label: '启用',
								value: 1,
							},
						],
					},
					{
						width: 180,
						label: '创建时间',
						prop: 'createdAt',
						type: 'datetime',
						format: 'yyyy-MM-dd HH:mm',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
						editDisplay: false,
						addDisplay: false,
						span: 24,
					},
				],
			},
			checkedKeys: [],
			defaultProps: {
				label: 'name',
				value: 'id',
			},
			maxLength: 200,
			Isasync: false,
			page: {
				total: 0, // 总页数
				currentPage: 1, // 当前页数
				pageSize: 20, // 每页显示多少条,
				pageSizes: [10, 20, 30, 40, 50, 100, 1000],
				isAsc: false, // 是否倒序
			},
			list: [],
			listLoading: true,
			form: {},
			editShowing: false,
		}
	},
	created() {
		// this.getChannelList()
		// this.getChannelAttrList()
		// this.getChannelFromList()
		// this.getAreaList()
		this.initTreeData()
	},
	computed: {
		...mapGetters(['elements', 'permissions']),
	},

	methods: {
		onRowClick({userName = '', channelId = ''}) {
			//触发树搜索
			// if (userName) {
			// let tree = this.$refs.treeselect
			// this.Isasync = true;
			// tree.trigger.searchQuery = userName
			// }
			if (channelId) {
				// this.Isasync = false;
				this.initTreeData(channelId)
			}
		},
		async asyncOptions({action, searchQuery, callback}) {
			if (action === ASYNC_SEARCH) {
				this.loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)',
				})
				let res = await this.getList({name: searchQuery})
				let result = res.data.data || []
				//大于最多 200 条数据限制
				if (result.length > this.maxLength) {
					result.length = this.maxLength
				}
				let options = result

				const expandAllChildren = function (data) {
					return data.map((item) => {
						const newItem = {...item, isDefaultExpanded: true}
						if (newItem.children && Array.isArray(newItem.children)) {
							newItem.children.isDefaultExpanded = true
							newItem.children = expandAllChildren(newItem.children)
						}
						return newItem
					})
				}

				const expandedOptions = expandAllChildren(options)
				console.log('expandedOptions', expandedOptions, this.$refs.treeselect)
				this.loading.close()
				callback(null, expandedOptions)
			}
		},
		itemopen() {
			this.Isasync = false
		},
		itemClose() {
			this.Isasync = false
		},
		async loadOptions({action, parentNode, searchQuery, callback}) {
			//如果是点击展开下一级
			if (action === LOAD_CHILDREN_OPTIONS) {
				//加载点击节点的 子节点
				this.getList({id: parentNode.id}).then((response) => {
					parentNode.children = response.data.data
						? response.data.data.map((item) => ({
								...item,
								children: item.leaf ? undefined : null,
						  }))
						: []
				})
				callback()
			}
		},
		treeSearchChange(e) {
			console.log('treeSearchChange-e', e)
			setTimeout(() => {
				if (e) {
					this.Isasync = true
				} else {
					this.initTreeData()
					this.Isasync = false
				}
			}, 50)
		},
		getList({name, id, currentChannelId = ''}) {
			let query = {name, parentId: id, currentChannelId}
			return distChannelByName(query)
		},
		async initTreeData(currentChannelId = '') {
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0)',
			})
			let res
			if (currentChannelId) {
				this.initFlag = false
				this.Isasync = false
				res = await this.getList({currentChannelId})
			} else {
				res = await this.getList({id: 0})
			}
			let result = res.data.data
			//大于最多 200 条数据限制
			if (result.length > this.maxLength) {
				result.length = this.maxLength
			}
			if (currentChannelId) {
				const expandAllChildren = function (data) {
					return data.map((item) => {
						const newItem = {...item, isDefaultExpanded: true}
						if (item.id == currentChannelId) {
							newItem.isNew = true
						}
						if (newItem.children && Array.isArray(newItem.children)) {
							newItem.children.isDefaultExpanded = true
							newItem.children = expandAllChildren(newItem.children)
						}
						return newItem
					})
				}

				let treeData = result.map((item) => ({
					...item,
					children: item.children ? item.children : item.leaf ? undefined : null,
				}))
				this.treeData = expandAllChildren(treeData)
				console.log('9999', this.treeData)
			} else {
				this.treeData = result.map((item) => ({
					...item,
					children: item.leaf ? undefined : null,
				}))
			}
			this.initFlag = true
			this.loading.close()
		},

		getChannelList() {
			fetchTree(this.listQuery).then((response) => {
				this.treeData = response.data.data
			})
		},
		getChannelAttrList() {
			dictList({fieldName: 'channel_attr'}).then((response) => {
				this.channelAttrList = response.data.data
			})
		},
		getChannelFromList() {
			dictList({fieldName: 'channel_from'}).then((response) => {
				this.channelFromList = response.data.data
			})
		},
		getAreaList() {
			areaList(2).then((response) => {
				this.areaList = response.data.data
			})
		},
		filterNode(value, data = {}) {
			if (!value) {
				return true
			}
			if (this.validatenull(data.name)) {
				return true
			}
			return data.name.indexOf(value) !== -1
		},

		chooseTree({id}) {
			this.getNodeData({id})
		},
		assetTreeKeydownFun(e) {
			//添加 loading
			const loading2 = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0)',
			})
			this.Isasync = true

			setTimeout(() => {
				loading2.close()
				if (!(e.target && e.target._value)) {
					this.Isasync = false
					this.initTreeData()
				}
			}, 50)
		},
		normalizer(node) {
			let noder = {
				id: node.id,
				isDefaultExpanded: node.isDefaultExpanded,
				label: node.name,
				children: node.children,
			}
			return noder
		},

		getNodeData(data) {
			this.searchForm = {}
			this.currentId = data.id
			this.page.currentPage = 1
			this.getRightList(this.page, {})
		},
		getRightList(page, params) {
			this.listLoading = true
			this.searchForm.channelId = this.currentId
			fetchList(
				Object.assign(
					{
						current: page.currentPage,
						size: page.pageSize,
					},
					params,
					this.searchForm,
				),
			).then((response) => {
				this.list = response.data.data.records
				this.page.total = response.data.data.total
				this.listLoading = false
			})
		},
		searchChange(param, done) {
			this.searchForm = param
			this.page.currentPage = 1
			this.getRightList(this.page, param)
			done()
		},
		searchReset() {
			this.currentId = ''
			this.searchForm = {}
			this.page.currentPage = 1
			this.getRightList(this.page)
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getRightList(this.page)
		},
		cellStyle({row, column, rowIndex, columnIndex}) {
			if (column.property == 'status') {
				if (row.status == 0) {
					return {
						color: 'red',
					}
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/styles/mixin';

.filter-tree {
	@include scrollBar;
}

/deep/ .el-card__header {
	padding: 8px 30px 8px 45px !important;
	font-size: 15px;
	font-weight: 300;
}

/deep/ .el-scrollbar__wrap {
	overflow-x: hidden;
	overflow-y: scroll;
	height: 100%;
}
</style>
